/**
 * Store sub context for user data
 */
const UserContext = {
  userSection: '',
  dischargeParams: {} as { accountNumbers: string[]; facilityId: string }
};

export default UserContext;
